import React, { useCallback } from 'react'

import { VisuallyHiddenInput } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { routing } from '@utils/routing'

import { getOfferTypeUtil } from '../../../../../Product.utils'
import type { ProductFormState } from '../../../../SingleProduct.types'
import { CategorySelect } from './components/CategorySelect'
import { useProductCategory } from './hooks/useProductCategory'
import type { ProductCategoryProps } from './types'

export const ProductCategory = ({ disabled }: ProductCategoryProps) => {
  const { values, setFieldValue, errors } = useFormikContext<ProductFormState>()
  const offerType = getOfferTypeUtil(values.manufacturingService)

  const handleCategorySelect = useCallback(
    (categoryId: string) => {
      setFieldValue('categoryId', categoryId)
    },
    [setFieldValue],
  )

  const {
    initialCategory,
    selectedCategory,
    parentCategory,
    selectCategory,
    options,
    areOptionsLoading,
    search,
    reset,
  } = useProductCategory({
    offerType,
    initialCategoryId: values.categoryId,
    onCategorySelect: handleCategorySelect,
  })

  return (
    <>
      {/* Hidden field for form validation and scrolling */}
      <VisuallyHiddenInput name="categoryId" />

      <CategorySelect
        label="Product category"
        suggestion={
          <>
            Required for calculating sales tax.{' '}
            <a href={routing.external.helpCenter.productCategory} target="_blank" rel="noreferrer">
              Learn more
            </a>
          </>
        }
        initialCategory={initialCategory}
        selectedCategory={selectedCategory}
        parentCategory={parentCategory}
        options={options}
        areOptionsLoading={areOptionsLoading}
        error={errors.categoryId}
        search={search}
        onSelect={selectCategory}
        disabled={disabled}
        onReset={reset}
      />
    </>
  )
}
